import makeStyles from '@mui/styles/makeStyles';
import colors from 'global/styles/colors';

const useStyles = makeStyles((theme) => ({
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: '100%',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    position: 'relative',
    padding: theme.spacing(4),
    maxWidth: 900,
    margin: '0 auto',
  },
  fullWidth: {
    width: '100%',
  },
  innerContainer: {
    padding: `0 ${theme.spacing(4)}`,

    '& h6': {
      fontSize: 14,
    },

    '& .MuiCheckbox-root': {
      padding: 1,
    },
    '& .MuiFormControlLabel-root': {
      marginLeft: 0,
    },
  },
  editButton: {
    marginTop: theme.spacing(1),
  },
  realmContainer: {
    position: 'relative',
    borderTop: `1px solid black`,
    margin: `${theme.spacing(2)} 0`,
  },
  realm: {
    padding: theme.spacing(1),
    position: 'relative',
    borderBottom: `1px solid black`,
  },
  delete: {
    position: 'absolute',
    top: 5,
    right: 5,
    color: colors.danger,
  },
  hideBorders: {
    borderBottom: 'none',
    borderTop: 'none',
  },
  italic: {
    fontStyle: 'italic',
  },
}));

export const tradeStyles = makeStyles(theme => ({
  container: {
    position: 'relative',
    padding: theme.spacing(1),
    '& .MuiTableCell-root': {
      fontSize: 14,
      padding: theme.spacing(1, 2),
    },
    '& tbody tr:last-child td': {
      borderBottom: 'none',
    },
  },
  headerCell: {
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
    fontSize: '13px !important',
    borderBottom: `2px solid ${theme.palette.divider}`,
  },
  enabledRow: {
    '& td': { color: theme.palette.text.primary },
  },
  disabledRow: {
    '& td': {
      color: theme.palette.text.disabled,
      fontStyle: 'italic',
    },
  },
  disabledText: {
    color: theme.palette.text.disabled,
    fontStyle: 'italic',
  },
}))

export default useStyles;
